/** A write waits out its Undo window. The toast shows the same six seconds; the clock here is the write's own. */
export const UNDO_MS = 6000;

export interface Held {
  /** Write now (the toast left, or the window is up). Once only. */
  flush: () => void;
  /** Undo: never write. */
  cancel: () => void;
}

const waiting = new Set<Held>();

/**
 * Holds `write` for the Undo window. A toast kept open under the pointer pauses its own clock, so the toast
 * leaving cannot be what writes: whichever comes first, the toast or this clock, flushes it.
 */
export function hold(write: () => void): Held {
  const held: Held = {
    flush: () => {
      if (waiting.delete(held)) {
        window.clearTimeout(timer);
        write();
      }
    },
    cancel: () => {
      waiting.delete(held);
      window.clearTimeout(timer);
    },
  };
  const timer = window.setTimeout(held.flush, UNDO_MS);
  waiting.add(held);
  return held;
}

/** Drops every write still waiting, without writing: for tests, so a window left open writes into no later one. */
export function dropHeld(): void {
  for (const held of [...waiting]) held.cancel();
}
